'use strict';

angular.module('docketbook').
controller('trialActivatedModalController', function(addressBookService, userService, uuid, $scope, $state, $window, $location, $stateParams, accessControl, $rootScope) {

    $scope.show = false

    $scope.$parent.showTrialActivatedModal = function(cb) {
        $scope.show = true
        $scope.cb = cb
    }
    
    $scope.closeDialog = function() {
        /*$scope.show = false
        if ($scope.cb) {
            $scope.cb()
        }*/
        //$('#trialActivatedModal').fadeOut(100)
        window.location.reload();
    }
})


// WEBPACK FOOTER //
// ./src/controllers/modals/trialActivatedModalController.js